<template>
    <div class="wrap" :class="{ wrap_en: $i18n.locale == 'EN' }">
        <my-header></my-header>
        <div class="section">
            <div class="banner">
                <p>{{ $t('Public.Agriculture.banner.title') }}</p>
            </div>
            <div class="content">
                <div class="service_intro">
                    <p class="detail_title">{{ $t('Public.Agriculture.serviceIntro.title') }}</p>
                    <div class="intro_text">{{ $t('Public.Agriculture.serviceIntro.text') }}</div>
                </div>
                <div class="big_data">
                    <p class="detail_title">{{ $t('Public.Agriculture.lovBigData.title') }}</p>
                    <div class="center_logo">
                        <img src="../../public/images/service/agriculture/center_logo.png" />
                    </div>
                    <div class="data_service">
                        <ul>
                            <li v-for="(item, index) in $t('Public.Agriculture.lovBigData.list')" :key="index">
                                <p>{{ item.title }}</p>
                                <span></span>
                                <div>{{ item.text }}</div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <my-footer></my-footer>
    </div>
</template>

<script>
import MyHeader from '@/components/MyHeader.vue';
import MyFooter from '@/components/MyFooter.vue';

export default {
    name: 'Agriculture',
    components: {
        MyHeader,
        MyFooter
    },
    data() {
        return {};
    }
};
</script>

<style scoped>
.banner {
    width: 100%;
    height: 4.4rem;
    padding: 1.45rem 0.45rem 0;
    background: url(../../public/images/service/agriculture/banner.png) no-repeat;
    background-size: cover;
    background-position: center;
    background-color: #0c1f3d;
}
.banner p {
    width: 4.4rem;
    font-size: 0.44rem;
    line-height: 1.35;
    color: #fff;
}
.wrap_en .banner p {
    width: 4.8rem;
}
.content {
    padding: 0.5rem 0.27rem 1.1rem;
}
.service_intro {
    margin-bottom: 0.76rem;
}
.detail_title {
    font-size: 0.42rem;
    font-weight: 500;
    text-align: center;
    line-height: 1.35;
}
.intro_text {
    margin-top: 0.45rem;
    color: #555;
    line-height: 1.75;
    text-indent: 2em;
    text-align: justify;
}
.wrap_en .intro_text {
    text-indent: 0;
}
.center_logo {
    width: 4.2rem;
    margin: 0.55rem auto 0.45rem;
}
.data_service ul {
    display: flex;
    flex-direction: column;
    gap: 0.28rem;
}
.data_service li {
    padding: 0.34rem 0.32rem;
    background: #fff;
    box-shadow: -0.03rem 0.04rem 0.18rem 0 rgba(0, 0, 0, 0.14);
    color: #666;
    line-height: 1.6;
}
.data_service li p {
    font-size: 0.3rem;
    font-weight: 500;
    color: #333;
    line-height: 1.35;
}
.data_service li span {
    display: inline-block;
    width: 0.44rem;
    height: 0.06rem;
    margin: 0.12rem 0 0.2rem;
    background: #05a3e4;
}
.data_service li div {
    text-align: justify;
}
.wrap_en .data_service li div {
    text-align: left;
}
</style>
